module.exports = __webpack_public_path__ + "media/images/forms/checkmark-light-4345d788fa94505dfe1dddd550f1ccc4.svg";